import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

class Alert extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        title: PropTypes.string,
        body: PropTypes.string,
        order_id: PropTypes.number,
        close_button: PropTypes.bool,
        footer: PropTypes.bool,
        show_progress_bar: PropTypes.bool,
        primary_button: PropTypes.string,
        secondary_button: PropTypes.string,
        temp_duration: PropTypes.number,
        onPrimaryButtonClick: PropTypes.func,
        onSecondaryButtonClick: PropTypes.func,
        onClose: PropTypes.func,
    };

    static defaultProps = {
        id: null,
        title: i18next.t('common:attention'),
        body: undefined,
        order_id: undefined,
        close_button: true,
        footer: true,
        show_progress_bar: false,
        primary_button: i18next.t('common:ok'),
        secondary_button: undefined,
        temp_duration: 5600,
        onPrimaryButtonClick: undefined,
        onSecondaryButtonClick: undefined,
        onClose: undefined,
    };

    render() {
        const {
            id,
            title,
            body,
            order_id,
            close_button,
            show_progress_bar,
            footer,
            primary_button,
            secondary_button,
            temp_duration,
            onPrimaryButtonClick,
            onSecondaryButtonClick,
            onClose,
        } = this.props;

        return (
            <div
                className="m2g-external-alert-container m2g-modal m2g-modal--small m2g-modal--alert"
                data-view="alert"
                data-id={id}
                data-title={title}
                ref={alert_container_ref =>
                    { this.alert_container_ref = alert_container_ref }
                }
            >
                <div className="m2g-modal-arrow" />
                {title && (
                    <div data-header className="m2g-modal-header">
                        {close_button && (
                            <button
                                data-close
                                className="m2g-modal-close-button"
                                onClick={onClose}
                            >
                                ×
                            </button>
                        )}
                        <span data-title className="m2g-modal-title">
                            {title}
                        </span>
                    </div>
                )}

                {body && (
                    <div
                        data-body
                        className="m2g-modal-body"
                        dangerouslySetInnerHTML={{ __html: body }}
                    />
                )}

                {order_id && (
                    <div
                        className="m2g-modal-order-id"
                    >
                        {`${i18next.t("common:order_id")} ${order_id}`}
                    </div>

                )}

                {footer && (
                    <div data-footer className="m2g-modal-footer">
                        {show_progress_bar && (
                            <div
                                data-progress-bar
                                className="m2g-modal-footer-progress-bar"
                                style={{
                                    animationDuration: `${temp_duration}ms`,
                                    MozAnimationDuration: `${temp_duration}ms`,
                                    WebkitAnimationDuration: `${temp_duration}ms`,
                                }}
                            />
                        )}

                        {primary_button && (
                            <div className="m2g-modal-footer-right">
                                {secondary_button && (
                                    <button
                                        data-secondary-button
                                        className="m2g-button m2g-button--secondary"
                                        onClick={onSecondaryButtonClick}
                                    >
                                        {secondary_button}
                                    </button>
                                )}
                                <button
                                    data-primary-button
                                    className="m2g-button m2g-button--primary"
                                    onClick={onPrimaryButtonClick}
                                >
                                    {primary_button}
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default Alert;
